/**
 * Renders the blue to red gradient bar on the home page
 */
import React from "react";

const HomeGradient = () => {
    return (
        <div className="hidden sm:block homegradient h-2 w-full bg-gradient-to-r from-blue-600 via-purple-600 to-red-600">
        </div>
    );
}
export default HomeGradient;